"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var rules = {
    provideLiquidityRule: {
        type: "from_contract",
        attributes: [
            ["contract_address"],
            ["action", "provide_liquidity"],
            ["assets"],
            ["share"],
            ["contract_address"],
            ["action"],
            ["from"],
            ["to"],
            ["by"],
            ["amount"],
            ["contract_address"],
            ["action"],
            ["to"],
            ["amount"],
        ],
    },
    provideLiquidityRuleTypeB: {
        type: "from_contract",
        attributes: [
            ["contract_address"],
            ["action", "provide_liquidity"],
            ["sender"],
            ["receiver"],
            ["assets"],
            ["share"],
            ["contract_address"],
            ["action"],
            ["from"],
            ["to"],
            ["by"],
            ["amount"],
            ["contract_address"],
            ["action"],
            ["to"],
            ["amount"],
        ],
    },
    withdrawLiquidityRuleTypeA: {
        type: "from_contract",
        attributes: [
            ["contract_address"],
            ["action", "send"],
            ["from"],
            ["to"],
            ["amount"],
            ["contract_address"],
            ["action", "withdraw_liquidity"],
            ["withdrawn_share"],
            ["refund_assets"],
            ["contract_address"],
            ["action"],
            ["from"],
            ["to"],
            ["amount"],
            ["contract_address"],
            ["action"],
            ["from"],
            ["amount"],
        ],
    },
    withdrawLiquidityRuleTypeB: {
        type: "from_contract",
        attributes: [
            ["contract_address"],
            ["action", "send"],
            ["from"],
            ["to"],
            ["amount"],
            ["contract_address"],
            ["action", "withdraw_liquidity"],
            ["withdrawn_share"],
            ["refund_assets"],
            ["contract_address"],
            ["action"],
            ["from"],
            ["amount"],
        ],
    },
    withdrawLiquidityRuleTypeC: {
        type: "from_contract",
        attributes: [
            ["contract_address"],
            ["action", "send"],
            ["from"],
            ["to"],
            ["amount"],
            ["contract_address"],
            ["action", "withdraw_liquidity"],
            ["sender"],
            ["withdrawn_share"],
            ["refund_assets"],
            ["contract_address"],
            ["action"],
            ["from"],
            ["to"],
            ["amount"],
            ["contract_address"],
            ["action", "burn"],
            ["from"],
            ["amount"],
        ],
    },
    transferRule: {
        type: "from_contract",
        attributes: [
            ["contract_address"],
            ["action", "transfer"],
            ["from"],
            ["to"],
            ["amount"],
        ],
    },
};
var create = function () {
    var provideLiquidityRuleSet = {
        rule: rules.provideLiquidityRule,
        transform: function (fragment, matched) { return ({
            msgType: "token/provide-liquidity",
            canonicalMsg: [
                "Provide ".concat(matched[2].value, " Liquidity to ").concat(matched[0].value),
                "Mint ".concat(matched[13].value).concat(matched[10].value),
            ],
            payload: fragment,
        }); },
    };
    var provideLiquidityRuleSetTypeB = {
        rule: rules.provideLiquidityRuleTypeB,
        transform: function (fragment, matched) { return ({
            msgType: "token/provide-liquidity",
            canonicalMsg: [
                "Provide ".concat(matched[4].value, " Liquidity to ").concat(matched[0].value),
                "Mint ".concat(matched[15].value).concat(matched[12].value),
            ],
            payload: fragment,
        }); },
    };
    var withdrawLiquidityRuleSetTypeA = {
        rule: rules.withdrawLiquidityRuleTypeA,
        transform: function (fragment, matched) { return ({
            msgType: "token/withdraw-liquidity",
            canonicalMsg: [
                "Withdraw ".concat(matched[8].value, " Liquidity from ").concat(matched[5].value),
                "Burn ".concat(matched[17].value).concat(matched[14].value),
            ],
            payload: fragment,
        }); },
    };
    var withdrawLiquidityRuleSetTypeB = {
        rule: rules.withdrawLiquidityRuleTypeB,
        transform: function (fragment, matched) { return ({
            msgType: "token/withdraw-liquidity",
            canonicalMsg: [
                "Withdraw ".concat(matched[8].value, " Liquidity from ").concat(matched[5].value),
                "Burn ".concat(matched[12].value).concat(matched[9].value),
            ],
            payload: fragment,
        }); },
    };
    var withdrawLiquidityRuleSetTypeC = {
        rule: rules.withdrawLiquidityRuleTypeC,
        transform: function (fragment, matched) { return ({
            msgType: "token/withdraw-liquidity",
            canonicalMsg: [
                "Withdraw ".concat(matched[9].value, " Liquidity from ").concat(matched[5].value),
                "Burn ".concat(matched[18].value).concat(matched[15].value),
            ],
            payload: fragment,
        }); },
    };
    var transferRuleSet = {
        rule: rules.transferRule,
        transform: function (fragment, matched) { return ({
            msgType: "token/transfer",
            canonicalMsg: [
                "Transfer ".concat(matched[4].value).concat(matched[0].value, " to ").concat(matched[3].value),
            ],
            payload: fragment,
        }); },
    };
    return [
        provideLiquidityRuleSet,
        provideLiquidityRuleSetTypeB,
        withdrawLiquidityRuleSetTypeA,
        withdrawLiquidityRuleSetTypeB,
        withdrawLiquidityRuleSetTypeC,
        transferRuleSet,
    ];
};
exports.default = create;
//# sourceMappingURL=index.js.map